import { WorkspaceLayout } from '@pwa/components/dashboard/workspace-layout';
import { createFileRoute } from '@tanstack/react-router';

function ClientLayoutWrapper() {
	const { orgId, wsId } = Route.useParams();
	return <WorkspaceLayout orgId={orgId} id={wsId} />;
}

export const Route = createFileRoute('/_dashboard/org/$orgId/ws/$wsId')({
	component: ClientLayoutWrapper,
});
